import { DashboardMetricSet } from './../../dashboard/dashboard-metric';
import { DashboardEventService } from './../../dashboard/dashboard-event.service';
import { Component, OnInit, ViewEncapsulation, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-dashboard-metric',
    templateUrl: './dashboard-metric.component.html',
    styleUrls: ['./dashboard-metric.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DashboardMetricComponent implements OnInit {
    @Input()
    dashboardMetricSet: DashboardMetricSet;
    @Input()
    index: number;
    initialized = false;


    constructor(private dashboardEventService: DashboardEventService) { }

    ngOnInit() {
        this.initialized = true;
    }

    onSelection() {
        this.dashboardEventService.dashboardMetricCategorySubject.next(this.dashboardMetricSet);
    }
}
